module.exports = __webpack_public_path__ + "static/media/pub.c2b66106.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/cat/pub.png
// module id = 113
// module chunks = 0